const UserMapViewPopupMode = {
    EDIT: 'EDIT',
    CREATE: 'CREATE',
};

export default UserMapViewPopupMode;
